<div class="tw-hidden lg:tw-flex tw-justify-between tw-mb-0 lg:tw-mb-3">
  <div class="tw-max-w-[78%]">
    <h1
      class="tw-min-w-0 tw-pe-2 tw-text-lg md:tw-text-xl tw-font-bold tw-leading-tight tw-whitespace-normal tw-break-words tw-hidden lg:tw-block"
      [ngClass]="{ 'tw-cursor-pointer': !archived() && canEdit() }"
      (click)="navigateToEdit()"
    >
      {{ event().name }}
    </h1>
  </div>
  <div class="tw-flex tw-gap-2">
    @if (canEdit() && !archived()) {
      <button
        type="button"
        class="tw-flex tw-border-blue-600 tw-border tw-rounded-md tw-p-3 tw-font-medium tw-text-xs tw-font-inter tw-gap-2 tw-text-blue-600 tw-h-[34px] tw-items-center"
        (click)="navigateToEdit()"
      >
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_43988_7130)">
            <path
              d="M9.33872 0.465904L8.38084 1.47763L10.586 3.80671L11.5432 2.79499C11.688 2.64207 11.8029 2.46052 11.8813 2.26071C11.9597 2.06089 12 1.84673 12 1.63045C12 1.41416 11.9597 1.2 11.8813 1.00018C11.8029 0.800369 11.688 0.61882 11.5432 0.465904C11.2461 0.166831 10.8514 0 10.441 0C10.0305 0 9.63584 0.166831 9.33872 0.465904Z"
              fill="#1C64F2"
            />
            <path
              d="M9.70416 4.73808L7.49904 2.409L4.55243 5.51862C4.46525 5.61052 4.4058 5.72764 4.38156 5.8552L4.05353 7.60201C4.03335 7.70838 4.03836 7.81836 4.0681 7.92219C4.09784 8.02602 4.15141 8.12049 4.22403 8.19719C4.29666 8.2739 4.38609 8.33047 4.4844 8.36189C4.5827 8.3933 4.68683 8.39859 4.78754 8.37727L6.44138 8.02817C6.56192 8.00245 6.67258 7.93966 6.75943 7.8477L9.70416 4.73808Z"
              fill="#1C64F2"
            />
            <path
              d="M4.55243 5.51862C4.46525 5.61052 4.4058 5.72764 4.38156 5.8552L4.05353 7.60201C4.03335 7.70838 4.03836 7.81836 4.0681 7.92219C4.09784 8.02602 4.15141 8.12049 4.22403 8.19719C4.29666 8.2739 4.38609 8.33047 4.4844 8.36189C4.5827 8.3933 4.68683 8.39859 4.78754 8.37727L6.44138 8.02817C6.56192 8.00245 6.67258 7.93966 6.75943 7.8477L9.70416 4.73808L7.49904 2.409L4.55243 5.51862Z"
              fill="#1C64F2"
            />
            <path
              d="M7.35436 8.61703C7.18011 8.80076 6.9584 8.92609 6.71702 8.97733L4.51189 9.44302C4.31059 9.48548 4.10248 9.47482 3.90602 9.41196C3.70955 9.3491 3.53082 9.236 3.38566 9.08269C3.24051 8.92938 3.13343 8.74059 3.07392 8.53309C3.01441 8.32558 3.00431 8.10577 3.04452 7.89315L3.48542 5.56407C3.53393 5.30911 3.65259 5.07494 3.82654 4.8909L6.89475 1.65021C6.87768 1.5888 6.86887 1.52517 6.86856 1.46117H1.35139C0.993077 1.46152 0.649539 1.61201 0.396176 1.87962C0.142814 2.14722 0.000330238 2.51007 0 2.88852V10.5726C0.000330238 10.9511 0.142814 11.3139 0.396176 11.5816C0.649539 11.8492 0.993077 11.9997 1.35139 12H8.62654C8.98485 11.9997 9.32839 11.8492 9.58175 11.5816C9.83512 11.3139 9.9776 10.9511 9.97793 10.5726V5.84598L7.35436 8.61703Z"
              fill="#1C64F2"
            />
          </g>
          <defs>
            <clipPath id="clip0_43988_7130">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Edit event
      </button>
    }

    @if (canAccessEventMenu() && visibleEventMenuOptions().length) {
      <app-dropdown
        [dropdownOptions]="visibleEventMenuOptions()"
        [widthInPX]="'auto'"
        [maxWidthInPX]="'250px'"
        [heightInPX]="0"
        [dropdownListXPosition]="'left'"
        [dropdownListYPosition]="'bottom'"
        (optionClicked)="onEventMenuOption($event)"
      >
        <button
          type="button"
          class="tw-border tw-border-gray-200 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-w-[34px] tw-h-[34px] tw-p-2.5 tw-cursor-pointer focus:tw-bg-gray-100 dropdownButton"
          aria-label="More options"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M12.6 8.39961C13.3732 8.39961 14 7.77281 14 6.99961C14 6.22641 13.3732 5.59961 12.6 5.59961C11.8268 5.59961 11.2 6.22641 11.2 6.99961C11.2 7.77281 11.8268 8.39961 12.6 8.39961Z"
              fill="currentColor"
            />
            <path
              d="M7 8.39961C7.7732 8.39961 8.4 7.77281 8.4 6.99961C8.4 6.22641 7.7732 5.59961 7 5.59961C6.2268 5.59961 5.6 6.22641 5.6 6.99961C5.6 7.77281 6.2268 8.39961 7 8.39961Z"
              fill="currentColor"
            />
            <path
              d="M1.4 8.39961C2.1732 8.39961 2.8 7.77281 2.8 6.99961C2.8 6.22641 2.1732 5.59961 1.4 5.59961C0.626801 5.59961 0 6.22641 0 6.99961C0 7.77281 0.626801 8.39961 1.4 8.39961Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </app-dropdown>
    }
  </div>
</div>

@if (isModalOpened(cloneModalId())) {
  <delete-modal
    [confirmBtnBgColorClass]="'tw-bg-blue-600'"
    [id]="cloneModalId()"
    [message]="cloneConfirmMessage()"
    (onDelete)="onCloneConfirmClick()"
    (onCancel)="closeCloneModal()"
  ></delete-modal>
}

@if (isModalOpened(archiveModalId())) {
  <delete-modal
    [id]="archiveModalId()"
    [message]="archiveConfirmMessage()"
    (onDelete)="onArchiveConfirmClick()"
    (onCancel)="closeArchiveModal()"
  ></delete-modal>
}

@if (isModalOpened(restoreModalId())) {
  <delete-modal
    [confirmBtnBgColorClass]="'tw-bg-blue-600'"
    [id]="restoreModalId()"
    [message]="restoreConfirmMessage()"
    (onDelete)="onRestoreConfirmClick()"
    (onCancel)="closeRestoreModal()"
  ></delete-modal>
}

@if (isModalOpened(deletePermanentlyModalId())) {
  <modal
    [id]="deletePermanentlyModalId()"
    [header]="'Delete event'"
    [headerIcon]="deleteHeaderIcon"
    [closeButtonEnabled]="true"
    [showHeaderDivider]="true"
    [showFooterDivider]="false"
    [widthClass]="'tw-w-[400px] sm:tw-w-[585px]'"
    [heightClass]="'tw-h-fit'"
    [enableBackdropClose]="!deletingPermanently()"
    [escapeToClose]="!deletingPermanently()"
    (onCloseModal)="closeDeletePermanentlyModal()"
  >
    <div slot="body" class="tw-flex tw-flex-col tw-gap-4 tw-font-inter">
      <p class="tw-font-inter tw-text-gray-700 tw-text-base">
        You are about to delete <span class="tw-font-semibold">{{ event().name | normalizeEventName }}</span>.
      </p>

      <div class="tw-flex tw-gap-2 tw-items-start">
        <svg class="tw-mt-1" width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="min-width: 19px;">
          <path d="M9.07031 0C9.5625 0 10.0195 0.28125 10.2656 0.703125L17.8594 13.6406C18.1055 14.0977 18.1055 14.625 17.8594 15.0469C17.6133 15.5039 17.1562 15.75 16.6641 15.75H1.47656C0.949219 15.75 0.492188 15.5039 0.246094 15.0469C0 14.625 0 14.0977 0.246094 13.6406L7.83984 0.703125C8.08594 0.28125 8.54297 0 9.07031 0ZM9.07031 4.5C8.57812 4.5 8.22656 4.88672 8.22656 5.34375V9.28125C8.22656 9.77344 8.57812 10.125 9.07031 10.125C9.52734 10.125 9.91406 9.77344 9.91406 9.28125V5.34375C9.91406 4.88672 9.52734 4.5 9.07031 4.5ZM10.1953 12.375C10.1953 11.7773 9.66797 11.25 9.07031 11.25C8.4375 11.25 7.94531 11.7773 7.94531 12.375C7.94531 13.0078 8.4375 13.5 9.07031 13.5C9.66797 13.5 10.1953 13.0078 10.1953 12.375Z" fill="#C27803"/>
        </svg>
        <p class="tw-font-inter tw-text-gray-700 tw-text-base">
          This action PERMANENTLY DELETES ALL EVENT DATA, including registrations, and cannot be reversed or recovered.
        </p>
      </div>

      <p class="tw-font-inter tw-text-gray-900 tw-text-base">
        To confirm, please type <span class="tw-font-semibold">Delete {{ event().name | normalizeEventName }}</span> below:
      </p>

      <basic-input
        [label]="'Confirmation'"
        [control]="permanentDeleteConfirmationControl"
        [placeholder]="'Confirmation'"
        [allowClearButton]="false"
      ></basic-input>

      <div class="tw-flex tw-justify-end tw-items-center tw-gap-3 tw-pt-2">
        <button
          type="button"
          class="tw-font-inter tw-inline-flex tw-items-center tw-justify-center tw-text-gray-900 tw-bg-white tw-border tw-border-gray-200 hover:tw-bg-gray-50 tw-font-medium tw-rounded-lg tw-text-sm tw-px-5 tw-py-2.5"
          (click)="closeDeletePermanentlyModal()"
        >
          Cancel
        </button>

        <button
          type="button"
          class="tw-font-inter tw-inline-flex tw-items-center tw-justify-center tw-text-white tw-bg-red-600 hover:tw-bg-red-700 tw-font-medium tw-rounded-lg tw-text-sm tw-px-5 tw-py-2.5"
          [buttonSpinner]="deletingPermanently()"
          [colorClass]="'tw-text-white'"
          (click)="onDeletePermanentlyConfirmClick()"
        >
          Delete event
        </button>
      </div>
    </div>
  </modal>
}
